import {  Toast } from 'antd-mobile'

const requestList = new Set()
let ToastRes:any
export const  requestLoadingMobile = async <T extends Promise<any>>(request:T)=>{
  if(requestList.size == 0){
    ToastRes = Toast.show({
      icon: 'loading',
      content: 'loading...',
      duration: 30000
    })
  }
  requestList.add(request)
  let response = await request
  requestList.delete(request)
  if(requestList.size == 0){
    ToastRes && ToastRes.close()
  }
  return response
}
